import React, { useContext } from 'react';
import styles from "./Sidebar.module.css"
import {NavLink} from 'react-router-dom';
import Icons,{ RiDashboardHorizontalLine,TbTransactionDollar,CgProfile,MdForwardToInbox} from "../Icons";
import Logo from '../Logo/Logo';
import noteContext from '../Context/NoteContext';
import { BiStats } from 'react-icons/bi';
export default function Sidebar(){
        const {
        expenseList, setExpenseList,
        edittmp, setedittmp,
        ind, setind,
        categories, setCategories,
        isModal, setisModal,
        modalType, setModalType,
        allCat, setAllCat,
        isProfile, setIsProfile,
        Income, setIncome,
        Expense, setExpense,
        searchQuery, setSearchQuery,
        isSearch, setIsSearch,
        isMenuOpen,setIsMenuOpen
    } = useContext(noteContext);
    return(
        <div className={`${isMenuOpen?styles.sidebarMobile:""} ${styles.sidebar}`}>
            <div className={styles.logo}>
              <Logo/>  
            </div>
            <ul>
                <li><NavLink  className={({ isActive }) => isActive ? `${styles.Link} ${styles.active}` : styles.Link} to="./"><RiDashboardHorizontalLine size={24}/>Dashboard</NavLink></li>
                <li><NavLink className={({ isActive }) => isActive ? `${styles.Link} ${styles.active}` : styles.Link} to='/Transctions'><TbTransactionDollar size={24}/>Transctions</NavLink></li>
                <li><NavLink className={({ isActive }) => isActive ? `${styles.Link} ${styles.active}` : styles.Link} to='/Account'><CgProfile size={24}/>Profile</NavLink></li>
                <li><NavLink className={({ isActive }) => isActive ? `${styles.Link} ${styles.active}` : styles.Link} to='/Inbox'><MdForwardToInbox size={24}/>Inbox</NavLink></li>
                <li className={styles.stats}><NavLink className={({ isActive }) => isActive ? `${styles.Link} ${styles.active}` : styles.Link} to='/Stats'><BiStats size={24}/>Stats</NavLink></li>
            </ul>
        </div>
    )
}